import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=2e0e9d4d"
import script from "./Groups.vue?vue&type=script&lang=ts"
export * from "./Groups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0e9d4d')) {
      api.createRecord('2e0e9d4d', component.options)
    } else {
      api.reload('2e0e9d4d', component.options)
    }
    module.hot.accept("./Groups.vue?vue&type=template&id=2e0e9d4d", function () {
      api.rerender('2e0e9d4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/Groups.vue"
export default component.exports